<div class="home-stage">
  <div class="home-stage__wrapper">
    <!-- Teaser 1 -->
    <div class="home-stage__big">
      <hdi-image
        class="home-stage__image"
        [src]="teaser1_image"
        [title]="teaser1_imageTitle"
        [alt]="teaser1_imageAlt"
      ></hdi-image>
      <div class="home-stage__content">
        <h1 class="home-stage__headline" [innerHTML]="teaser1_header"></h1>
        <hdi-link
          *ngIf="teaser1_label && teaser1_href"
          [href]="teaser1_href"
          [label]="teaser1_label | capitalize"
          [title]="teaser1_title"
          [hrefType]="teaser1_hrefType"
          [fragment]="teaser1_fragment"
          [iconPrefix]="'far'"
        ></hdi-link>
      </div>
    </div>
  </div>
  <div class="home-stage__wrapper">
    <!-- Teaser 2 -->
    <div class="home-stage__small">
      <div class="home-stage__content">
        <h4 class="home-stage__headline" [innerHTML]="teaser2_header"></h4>
        <hdi-button
          class="home-stage__button"
          *ngIf="teaser2_label && teaser2_href"
          [type]="ButtonType.PRIMARY_ICON"
          [href]="teaser2_href"
          [label]="teaser2_label | capitalize"
          [title]="teaser2_title"
          [hrefType]="teaser2_hrefType"
          [fragment]="teaser2_fragment"
          [iconPrefix]="'far'"
        ></hdi-button>
      </div>
      <hdi-icon
        [size]="Sizes.XXLARGE"
        [color]="BgColors.GREEN"
        [iconName]="teaser2_icon"
        [iconPrefix]="'fal'"
      ></hdi-icon>
    </div>

    <!-- Teaser 3 -->
    <div class="home-stage__medium">
      <hdi-image
        class="home-stage__image"
        [src]="teaser3_image"
        [title]="teaser3_imageTitle"
        [alt]="teaser3_imageAlt"
      ></hdi-image>
      <div class="home-stage__content">
        <h4 class="home-stage__headline" [innerHTML]="teaser3_header"></h4>
        <hdi-link
          *ngIf="teaser3_label && teaser3_href"
          [label]="teaser3_label | capitalize"
          [href]="teaser3_href"
          [hrefType]="teaser3_hrefType"
          [title]="teaser3_title"
          [fragment]="teaser1_fragment"
        ></hdi-link>
      </div>
    </div>
  </div>
</div>
